import { createFileRoute, redirect } from '@tanstack/react-router';

// The product is called Sequences again. Keep links and bookmarks to the
// Campaigns name working by redirecting them.
export const Route = createFileRoute('/campaigns/')({
  beforeLoad: () => {
    throw redirect({ to: '/sequences', replace: true });
  },
});
